import { Components, Theme } from '@mui/material/styles';

import { BlackHeadings, BlackSmall, HoverBackground } from 'src/theme/colors';

const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: {
      minHeight: 'unset',
      padding: '6px 16px',
      color: BlackSmall,
      '&:hover': {
        color: BlackHeadings,
        background: HoverBackground,
      },
    },
  },
};

export default MuiMenuItem;
